import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtro'
})
export class FiltroPipe implements PipeTransform {

  transform(arreglo: any[], textoFiltro: string, columnasFiltro: string[]): any[] {

    // console.log({ textoFiltro, columnasFiltro });
    if (arreglo) {
      if (textoFiltro === '' || textoFiltro === undefined) {
        return arreglo;
      } else {
        textoFiltro = textoFiltro.trim().toLowerCase();

        arreglo = arreglo.filter((item: any) => {

          for (const iterator of columnasFiltro) {
            if ((item[iterator] || '')
              .toString()
              .trim()
              .toLowerCase()
              .indexOf(textoFiltro) > -1) {
              return true;
            }
          }
        });
        // console.log({ arreglo });

        return arreglo;

      }
    } else {
      return [];
    }
  }

}
